import dayjs from 'dayjs'

export const getOrdinal = function (d: number) {
    if (d > 3 && d < 21) return 'th'
    switch (d % 10) {
        case 1:
            return 'st'
        case 2:
            return 'nd'
        case 3:
            return 'rd'
        default:
            return 'th'
    }
}

export const getDateFromDay = (day: string) => {
    const dayNumber = Number(day)
    const today = new Date()

    const currentDay = today.getDate()
    const currentMonth = today.getMonth() + 1
    const currentYear = today.getFullYear()

    let year = currentYear
    let month = dayNumber > currentDay ? currentMonth : currentMonth + 1

    if (month === 13) {
        month = 1
        year += 1
    }

    return dayjs(`${month}/${dayNumber}/${year} 09:00:00`, 'M/D/YYYY HH:mm:ss')
}
